import styled from '@emotion/styled';

import { mq, shouldForwardProp } from '@hrworks/design-system/utilities';

import { Sidebar } from '../Sidebar/Sidebar';
import { S as SqwLayoutStyles } from '../SqwLayout.styles';

type SidebarCollapseStyledProps = { $isSidebarCollapsed: boolean };

const DesktopSidebar = styled(Sidebar, {
  shouldForwardProp,
})<SidebarCollapseStyledProps>(({ theme, $isSidebarCollapsed }) => ({
  '&&&': {
    gridArea: 'sidebar',
    overflow: 'hidden',
    minHeight: 0,
    flexShrink: 0,
    boxShadow: `1px 0 0 0 ${theme.eclipseTier2Color.border.nav.subtle}`,
    transform: 'translateX(0)',

    ...($isSidebarCollapsed && {
      visibility: 'hidden',
      transform: 'translateX(-100%)',
    }),

    [mq.conditionalTransition]: {
      transition: `transform ${theme.variables.animationDuration.long}, visibility ${theme.variables.animationDuration.long}`,
    },

    [mq.isSmallDevice]: {
      display: 'none',
    },
  },
}));

const MobileSidebar = styled(Sidebar, {
  shouldForwardProp,
})<{
  isExpanded?: boolean;
}>(({ theme, isExpanded }) => {
  const sidebarAnimationParam = `left cubic-bezier(.34,.92,.48,.96) ${theme.variables.animationDuration.long}`;

  return {
    //fix specificity after "FE-3767: unstyled CollapsibleMenu"
    '&&&': {
      position: 'fixed',
      top: 0,
      left: -SqwLayoutStyles.componentConfig(theme).sidebar.width,
      transition: `visibility ${theme.variables.animationDuration.long}, ${sidebarAnimationParam}`,
      display: 'none',

      [mq.isSmallDevice]: {
        display: 'flex',
        visibility: 'hidden',
        height: '100%',

        ...(isExpanded && {
          left: 0,
          visibility: 'visible',
          transition: `visibility 0s, ${sidebarAnimationParam}`,
        }),
      },
    },
  };
});

export const S = {
  DesktopSidebar,
  MobileSidebar,
};
